import React from 'react';
import styles from './styles.scss';
import auth0 from 'auth0-js';
import { Button } from '@densityco/ui';
import { Hosts } from '../../utils/host';

export class LoginAuth0 extends React.PureComponent<{
  location: { pathname: string; search: string };
}> {
  private webAuth: auth0.WebAuth;

  constructor(props) {
    super(props);

    this.webAuth = new auth0.WebAuth({
      domain: 'auth.density.io',
      clientID: Hosts.ClientId,
      redirectUri: `${window.location.protocol}//${window.location.host}`,
      responseType: 'id_token token',
      scope: 'openid profile email',
      audience: 'https://density.io/sensei',
    });
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <Button
          variant="filled"
          width="auto"
          onClick={() => {
            // Store the orginating origin in localStorage from the oauth request. This is used so
            // that we can redirect to the login route on the correct version of the sensei as
            // soon as possible in the oauth callback. For example, a user tried to login via oauth
            // on a preview link, normally, it would redirect to the staging sensei, not the
            // preview link. Store the current url so we can redirect back to here after logging in.
            const hashIndex = window.location.href.indexOf('#');
            window.localStorage.loginOAuthOrigin = window.location.href
              .slice(0, hashIndex)
              .replace(/\/$/, '');
            window.localStorage.loginNext =
              new URLSearchParams(this.props.location.search).get('next') ||
              '/';

            this.webAuth.authorize({
              connection: 'google-oauth2',
            });
          }}
        >
          Log in with Google
        </Button>
      </div>
    );
  }
}

export function LoginInvalidScopes() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Invalid Scopes</h1>
      <p>
        In order to use Sensei, please talk to @ryan on slack to get yourself
        added to the correct auth0 groups.
      </p>
    </div>
  );
}
